import { AccordionCard, AccordionRoot } from "../../../../accordion/Accordion";
import InteresseOmraader from "./InteresseOmraader";
import Beskikkelser from "./Beskikkelser";
import FirmaRelationer from "./FirmaRelationer";
import UdenlandskAdvokatsamfund from "./UdenlandskAdvokatsamfund";
import PersonRelationer from "./PersonRelationer";
import PersonArt from "./PersonArt";
import Persontyper from "./Persontyper";
import { PersonDto } from "../../../../../interfaces/schema";
import StamoplysningerTop from "./stamoplysningerTop/StamoplysningerTop";
import { useState } from "react";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import {
  defaultPersonArtColumns,
  defaultPersonBeskikkelserColumns,
  defaultPersonFirmaRelationColumns,
  defaultPersonInteresseColumns,
  defaultPersonPrincipalPersonFuldmColumns,
  defaultPersonPrincipalPersonPrincipalNavigationColumns,
  defaultPersonTyperColumns,
  defaultUdenlandskAdvokatsamfundColumns,
} from "../../../../../config/person";

export default function Stamoplysninger({
  toggleCpr,
  setToggleCpr,
  person,
  refetch,
}: {
  toggleCpr: boolean;
  setToggleCpr: React.Dispatch<React.SetStateAction<boolean>>;
  person: PersonDto;
  refetch: InvalidateDataFunction<any>;
}) {
  const [editMode, setEditMode] = useState(false);
  const [personArtColumns, setPersonArtActiveColumns] = useActiveColumns(
    "person-personart-active-columns",
    defaultPersonArtColumns,
  );
  const [personFirmaRelationColumns, setPersonFirmaRelationActiveColumns] =
    useActiveColumns(
      "person-personfirma-active-columns",
      defaultPersonFirmaRelationColumns,
    );

  const [personBeskikkelserColumns, setPersonBeskikkelserActiveColumns] =
    useActiveColumns(
      "person-beskikkelser-active-columns",
      defaultPersonBeskikkelserColumns,
    );
  const [personTyperColumns, setPersonTyperActiveColumns] = useActiveColumns(
    "person-persontyper-active-columns",
    defaultPersonTyperColumns,
  );
  const [personInteresseColumns, setPersonInteresseActiveColumns] =
    useActiveColumns(
      "person-personinteresse-active-columns",
      defaultPersonInteresseColumns,
    );
  const [
    personPrincipalPersonPrincipalNavigationColumns,
    setPersonPrincipalPersonPrincipalNavigationActiveColumns,
  ] = useActiveColumns(
    "person-personprincipal-active-columns",
    defaultPersonPrincipalPersonPrincipalNavigationColumns,
  );
  const [
    personPrincipalPersonFuldmColumns,
    setPersonPrincipalPersonFuldmActiveColumns,
  ] = useActiveColumns(
    "person-persinprincipalfulm-active-columns",
    defaultPersonPrincipalPersonFuldmColumns,
  );
  const [
    udenlandskAdvokatsamfundColumns,
    setUdenlandskAdvokatsamfundActiveColumns,
  ] = useActiveColumns(
    "person-udenlandsk-advokatsamfund-active-columns",
    defaultUdenlandskAdvokatsamfundColumns,
  );
  const { personFirma, personBeskikkelse } = person;

  return (
    <div className="container">
      <StamoplysningerTop
        editMode={editMode}
        setEditMode={setEditMode}
        person={person}
        toggleCpr={toggleCpr}
        setToggleCpr={setToggleCpr}
        invalidateData={refetch}
      />
      <AccordionRoot localstorageKey="person-id-stamoplysninger-accordion-value">
        <AccordionCard
          title="Beskikkelse"
          value="beskikkelser"
          isEmpty={!personBeskikkelse?.length}
          localstorageKey="person-id-stamoplysninger-accordion-value"
        >
          <Beskikkelser
            person={person}
            personBeskikkelserColumns={personBeskikkelserColumns}
            setPersonBeskikkelserActiveColumns={
              setPersonBeskikkelserActiveColumns
            }
            refetch={refetch}
          />
        </AccordionCard>

        <AccordionCard
          title="Firmarelationer"
          value="firmarelationer"
          isEmpty={!personFirma?.length}
          localstorageKey="person-id-stamoplysninger-accordion-value"
        >
          <FirmaRelationer
            person={person}
            personFirmaRelationColumns={personFirmaRelationColumns}
            setPersonFirmaRelationActiveColumns={
              setPersonFirmaRelationActiveColumns
            }
            invalidateData={refetch}
          />
        </AccordionCard>
        <AccordionCard
          title="Personrelationer"
          value="personrelationer"
          isEmpty={
            !person.personPrincipalPersonPrincipalNavigation?.length &&
            !person.personPrincipalPersonFuldm?.length
          }
          localstorageKey="person-id-stamoplysninger-accordion-value"
        >
          <PersonRelationer
            invalidateData={refetch}
            person={person}
            personPrincipalPersonFuldmColumns={
              personPrincipalPersonFuldmColumns
            }
            personPrincipalPersonPrincipalNavigationColumns={
              personPrincipalPersonPrincipalNavigationColumns
            }
            setPersonPrincipalPersonFuldmActiveColumns={
              setPersonPrincipalPersonFuldmActiveColumns
            }
            setPersonPrincipalPersonPrincipalNavigationActiveColumns={
              setPersonPrincipalPersonPrincipalNavigationActiveColumns
            }
          />
        </AccordionCard>
        <AccordionCard
          title="Interesseområder"
          value="interesseomraader"
          isEmpty={!person.personInteresse?.length}
          localstorageKey="person-id-stamoplysninger-accordion-value"
        >
          <InteresseOmraader
            person={person}
            personInteresseColumns={personInteresseColumns}
            setPersonInteresseActiveColumns={setPersonInteresseActiveColumns}
            invalidateData={refetch}
          />
        </AccordionCard>
        <AccordionCard
          title="Persontyper"
          value="persontyper"
          isEmpty={!person.personPersontype?.length}
          localstorageKey="person-id-stamoplysninger-accordion-value"
        >
          <Persontyper
            personId={person.id}
            personTyper={person.personPersontype}
            columns={personTyperColumns}
            setActiveColumns={setPersonTyperActiveColumns}
            invalidateData={refetch}
          />
        </AccordionCard>
        <AccordionCard
          title="Udenlandsk advokatsamfund"
          value="eu"
          isEmpty={!person.personUdenlandskadvokatsamfund?.length}
          localstorageKey="person-id-stamoplysninger-accordion-value"
        >
          <UdenlandskAdvokatsamfund
            person={person}
            udenlandskAdvokatsamfundColumns={udenlandskAdvokatsamfundColumns}
            setUdenlandskAdvokatsamfundActiveColumns={
              setUdenlandskAdvokatsamfundActiveColumns
            }
          />
        </AccordionCard>
        <AccordionCard
          title="Personart"
          value="personart"
          isEmpty={!person.personPersonart?.length}
          localstorageKey="person-id-stamoplysninger-accordion-value"
        >
          <PersonArt
            columns={personArtColumns}
            person={person}
            setActiveColumns={setPersonArtActiveColumns}
          />
          <div className="py2-">&nbsp;</div>
        </AccordionCard>
      </AccordionRoot>
    </div>
  );
}
